import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-external-issues-details',
  templateUrl: './external-issues-details.component.html',
  styleUrls: ['./external-issues-details.component.css']
})
export class ExternalIssuesDetailsComponent implements OnInit {
  IS_Id:any;
  mode:any;
  issueresList;
  issue:any={};
  statusList;
  IS_Ticket_No:any;
  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetexternStatus();
    this.route.params.subscribe(params =>
      this.IS_Id = params['IS_Id']
    );
    this.route.params.subscribe(params =>
      this.IS_Ticket_No = params['IS_Ticket_No']
    );
    this.route.params.subscribe(params =>
      this.mode = params['mode']
    );
    
      
    if (this.IS_Id != null && this.mode != null)
    this.GetIssueForexternTheId(this.IS_Id);
    this.GetIssueexternResponse(this.IS_Ticket_No,this.IS_Id);
  }
  GetIssueForexternTheId(IS_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetIssueForexternTheId(IS_Id)
      .subscribe(
        (data: any) => {
          this.issue = data;
          console.log('Exteral Issues');
          console.log( this.issue);
          if (this.issue.IS_Exp_Delivery != null)
          this.issue.IS_Exp_Delivery = ((this.issue.IS_Exp_Delivery).split('T'))[0];
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetIssueexternResponse(IS_Ticket_No,IS_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetIssueexternResponse(IS_Ticket_No,IS_Id)
      .subscribe(
        (data: any) => {
          this.issueresList = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetexternStatus() {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetexternStatus()
      .subscribe(
        (data: any) => {
          this.statusList = data;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/issues/external-issues-details/external-issues-details.component.ts